var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftSwipeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 582"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 13.5,
    cy: 13.5,
    r: 11.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.38548 14.0519C9.39099 14.2943 9.48376 14.5259 9.64584 14.702L15.3591 20.8207C15.5349 21.0074 15.7755 21.1149 16.0282 21.1195C16.2809 21.1241 16.5251 21.0255 16.7073 20.8453C16.8894 20.6652 16.9947 20.4181 16.9999 20.1583C17.0052 19.8985 16.91 19.6471 16.7353 19.4593L11.6544 14.0213L16.7353 8.58334C16.91 8.39553 17.0052 8.14418 16.9999 7.88436C16.9947 7.62455 16.8894 7.37748 16.7073 7.1973C16.5251 7.01712 16.2809 6.91854 16.0282 6.92316C15.7755 6.92778 15.5349 7.03523 15.3591 7.22196L9.64584 13.3406C9.55852 13.4354 9.4905 13.5471 9.44579 13.6692C9.40107 13.7914 9.38057 13.9215 9.38548 14.0519Z",
    fill: "#0081DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSwipeIcon);
export default __webpack_public_path__ + "static/media/leftSwipeIcon.3f8cde50eaea5565e7653ebcba6a17da.svg";
export { ForwardRef as ReactComponent };